import { ComponentStore } from '@ngrx/component-store';

export abstract class ComponentEffects extends ComponentStore<any> {
  // unset store functions, except effects
  updater = null as any;
  setState = null as any;
  patchState = null as any;
  select = null as any;
}
